module.exports = __webpack_public_path__ + "img/zone.2953d380.png";